var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { UserGuideModel } from './types/user-guide-model.interface';
import { UserGuideApi } from './types/user-guide-api.interface';
import { USER_GUIDE_LOCAL_STORAGE_KEY } from './constants';
import { UserService } from '@/domains/user/services/user-service.interface';
let UserGuideServiceImpl = class UserGuideServiceImpl {
    constructor(userGuideModel, userGuideApi, userService) {
        this.userGuideModel = userGuideModel;
        this.userGuideApi = userGuideApi;
        this.userService = userService;
    }
    async init() {
        const userGuideData = this._getUserGuideFromLocalStorage();
        if (userGuideData) {
            this.userGuideModel.updateUserGuide(userGuideData);
            return;
        }
        this.getUserGuide().then(userGuideData => {
            this.userGuideModel.updateUserGuide(userGuideData);
            this._setUserGuideToLocalStorage(userGuideData);
        });
    }
    getUserGuide() {
        return this.userGuideApi.getUserGuide();
    }
    updateUserGuide(userGuide) {
        this.userGuideModel.updateUserGuide(userGuide);
        this._setUserGuideToLocalStorage(this.userGuideModel.userGuide);
    }
    subscribeUserGuide(callback) {
        return this.userGuideModel.subscribeUserGuide(callback);
    }
    _getUserGuideFromLocalStorage() {
        const userGuideData = localStorage.getItem(USER_GUIDE_LOCAL_STORAGE_KEY);
        if (userGuideData) {
            try {
                const localData = JSON.parse(userGuideData);
                if (localData?.currentUserId === this.userService.userInfo.account_id) {
                    return localData.userGuideData;
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        return null;
    }
    _setUserGuideToLocalStorage(userGuideData) {
        localStorage.setItem(USER_GUIDE_LOCAL_STORAGE_KEY, JSON.stringify({
            currentUserId: this.userService.userInfo.account_id,
            userGuideData,
        }));
    }
    _clearUserGuideFromLocalStorage() {
        localStorage.removeItem(USER_GUIDE_LOCAL_STORAGE_KEY);
    }
};
UserGuideServiceImpl = __decorate([
    injectable(),
    __param(0, inject(UserGuideModel)),
    __param(1, inject(UserGuideApi)),
    __param(2, inject(UserService)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserGuideModel !== "undefined" && UserGuideModel) === "function" ? _a : Object, typeof (_b = typeof UserGuideApi !== "undefined" && UserGuideApi) === "function" ? _b : Object, typeof (_c = typeof UserService !== "undefined" && UserService) === "function" ? _c : Object])
], UserGuideServiceImpl);
export { UserGuideServiceImpl };
